import createIcon from '../../createIcon';

/**
 * @component @name ThirtyfpsSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAzVjVIOVY3SDVWOUg5VjExSDRWMTNIOUMxMC4xIDEzIDExIDEyLjEgMTEgMTFWOS41QzExIDguNjcgMTAuODMgOCAxMCA4QzEwLjgzIDggMTEgNy4zMyAxMSA2LjVWNUMxMSAzLjkgMTAuMSAzIDkgM0g0Wk0xOCAzQzE5LjEgMyAyMCAzLjkgMjAgNVYxMUMyMCAxMi4xIDE5LjEgMTMgMTggMTNIMTVDMTMuOSAxMyAxMyAxMi4xIDEzIDExVjVDMTMgMy45IDEzLjkgMyAxNSAzSDE4Wk0xOCA1SDE1VjExSDE4VjVaTTUgMjFIM1YxNkg1VjIxWk05IDIxSDdWMTZIOVYyMVpNMTMgMjFIMTFWMTZIMTNWMjFaTTIxIDIxSDE1VjE2SDIxVjIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThirtyfpsSelect = createIcon('ThirtyfpsSelect', [
  [
    'path',
    {
      d: 'M4 3V5H9V7H5V9H9V11H4V13H9C10.1 13 11 12.1 11 11V9.5C11 8.67 10.83 8 10 8C10.83 8 11 7.33 11 6.5V5C11 3.9 10.1 3 9 3H4ZM18 3C19.1 3 20 3.9 20 5V11C20 12.1 19.1 13 18 13H15C13.9 13 13 12.1 13 11V5C13 3.9 13.9 3 15 3H18ZM18 5H15V11H18V5ZM5 21H3V16H5V21ZM9 21H7V16H9V21ZM13 21H11V16H13V21ZM21 21H15V16H21V21Z',
      key: '88j9di',
    },
  ],
]);

export default ThirtyfpsSelect;
